<template>
  <div style="height: 100vh;" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <div>
  
      <div>
        <div>
          <div :class="header == true ? 'block' : 'block1'"  style="display: flex;justify-content: space-between;width: 100%;height:60px">
            <!-- <span class="span_box_two" v-if="tableData.length == '' ? false : true"></span> -->
            <div id="form" style="margin-top: 16px; margin-left: 11px;    display: flex; height: 30px;">
                <span @click="cleanUpEvt" class="all_text">All</span>
                <el-date-picker v-model="value2" type="daterange" start-placeholder="开始日期" value-format="timestamp"
                end-placeholder="结束日期" align="right" :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd"
                range-separator="-" style="width: 240px;margin:0 5px;" @change="getList"
                :class="{ 'your-css-class_box': !isValue2Empty_box }" class="border_box">
                </el-date-picker>
                <el-dropdown @command="RechargeEvt" class="num_box ">
                <el-button type="primary" size="mini" :class="RechargeName !== '请选择' ? 'vip-button' : 'selt'">
                    {{ RechargeName }}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                    <i class="el-icon-circle-close clear_ev" @click="clearEvt1" v-show="RechargeName !== '请选择'"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="4">会员购买</el-dropdown-item>
                    <el-dropdown-item command="5">购买点数</el-dropdown-item>
                </el-dropdown-menu>
                </el-dropdown>
            </div>
            <div class="pagination_box">
              <el-input v-model="paginationInput" style="width: 50px" size="mini" @change="limitEvt"
                placeholder="to"></el-input>
              <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage1"
                :page-size="paginationInput - 0" layout="prev, pager, next, jumper" :total="total" :pager-count="5"
                :show-total="showTotal"></el-pagination>
            </div>
          </div>
        </div>
        <div style="margin-top: 60px;overflow: unset;border-bottom: 1px solid #e1e1e1; margin-top: 1px solid #e1e1e1;">
          <el-table ref="sortTable" :data="tableData" :cell-style="rowStyle" :summary-method="getSummaries" height="55%"
            :empty-text="dataLoaded ? '暂无数据' : '正在加载数据中...'" @sort-change="sortChangeEvt" show-summary
            style="width: 100%; margin-top: 58px; overflow: none">
            <!-- <el-table-column type="vlo" width="55"> </el-table-column> -->
            <el-table-column sortable="custom" prop="order_time" label="收入时间" align="left"  width="120"  label-class-name="source_ID" >
                <template slot-scope="props">
                    <span style="width:80px;display:flex;text-align: left;margin-left:35px;" >{{ props.row.order_time }}</span>
                </template>
            </el-table-column>  


            <el-table-column sortable="custom" prop="amount_total" width="160" label="收入金额" align="center">
            </el-table-column>
            <el-table-column sortable="custom" prop="username" width="200" label="用户" align="left"></el-table-column>
            <el-table-column sortable="custom" prop="source_type" label="收入类别" width="160"
              align="left"></el-table-column>
           
              <el-table-column sortable="custom" prop="create_time" label="初次登陆" align="left" width="160"  label-class-name="source_ID" >
                <template slot-scope="props">
                    <span style="width:80px;display:flex;text-align: left;margin-left:35px;" >{{ props.row.create_time }}</span>
                </template>
            </el-table-column> 

            <el-table-column sortable="custom" prop="recharge" width="160" label="老用户" align="center">
              <template slot-scope="props">
                <span :style="{ color: props.row.recharge == '1' ? '#d1d1d1' : '#333', }">
                  {{ props.row.recharge > 1 ? '是' : ' 否' }}
                </span>
              </template>
            </el-table-column>
            
            <el-table-column sortable="custom" prop="update_time" label="登录" align="left"  label-class-name="source_ID" >
                <template slot-scope="props">
                    <span style="width:80px;display:flex;text-align: left;margin-left:35px;" >{{ props.row.update_time }}</span>
                </template>
            </el-table-column>  
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { AdminIcoMeLabelApi } from "../../../apis/income";
const delay = (function () {
    let timer = 0;
    return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
})();
export default {
    data() {
        return {
            header: true,
            src: "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
            //备注
            remtInput: "",
            authorIdInput: "",
            localInput: "",
            last_login: "",
            //分页输入框数据
            paginationInput: 96,
            currentPage1: 1,
            type: 4,
            //分页总数据
            total: null,
            value2: "",
            isValue2Empty: true,
            RechargeName: "请选择",
            pickerOptions: {
                shortcuts: [
                    {
                        text: "今天",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            picker.$emit("pick", [
                                new Date(start.setHours(0, 0, 0, 0)),
                                new Date(end.setHours(23, 59, 59, 0))
                            ]);
                        }
                    },
                    {
                        text: "本周",
                        onClick(picker) {
                            const current = new Date();
                            let nowDayOfWeek = current.getDay();
                            if (nowDayOfWeek === 0) nowDayOfWeek = 7;
                            const dayNum = 1 * 24 * 60 * 60 * 1000;
                            const firstDate = new Date(
                                current.valueOf() - (nowDayOfWeek - 1) * dayNum
                            );
                            const lastDate = new Date(
                                new Date(firstDate).valueOf() + 6 * dayNum
                            );
                            // picker.$emit("pick", [firstDate, lastDate]);
                            picker.$emit("pick", [
                                new Date(firstDate.setHours(0, 0, 0, 0)),
                                new Date(lastDate.setHours(23, 59, 59, 0))
                            ]);
                        }
                    },
                    {
                        text: "当月",
                        onClick(picker) {
                            const date = new Date();
                            const year = date.getFullYear();
                            const month = date.getMonth();
                            let thisMonthStartDate = new Date(year, month, 1);
                            let thisMonthEndDate = new Date(year, month + 1, 0);
                            // picker.$emit("pick", [thisMonthStartDate, thisMonthEndDate]);
                            picker.$emit("pick", [
                                new Date(thisMonthStartDate.setHours(0, 0, 0, 0)),
                                new Date(thisMonthEndDate.setHours(23, 59, 59, 0))
                            ]);
                        }
                    },
                    {
                        text: "当年",
                        onClick(picker) {
                            var tYear = new Date().getFullYear();
                            var startTime = new Date(tYear, 0, 1); //当前年第一天
                            var endTime = new Date(tYear, 11, 31); //当前年最后一天
                            // picker.$emit("pick", [startTime, endTime]);
                            picker.$emit("pick", [
                                new Date(startTime.setHours(0, 0, 0, 0)),
                                new Date(endTime.setHours(23, 59, 59, 0))
                            ]);
                        }
                    },
                    {
                        text: "昨天",
                        onClick(picker) {
                            const temp = new Date();
                            temp.setTime(temp.getTime() - 3600 * 1000 * 24);
                            picker.$emit("pick", [
                                new Date(temp.setHours(0, 0, 0, 0)),
                                new Date(temp.setHours(23, 59, 59, 0))
                            ]);
                        }
                    },
                    {
                        text: "上周",
                        onClick(picker) {
                            const current = new Date(
                                new Date().getTime() - 60 * 60 * 24 * 7 * 1000
                            );
                            let nowDayOfWeek = current.getDay();
                            let diffToMonday =
                                current.getDate() -
                                nowDayOfWeek +
                                (nowDayOfWeek === 0 ? -6 : 1);
                            const firstDate = new Date(current.setDate(diffToMonday));
                            const lastDate = new Date(current.setDate(diffToMonday + 6));
                            picker.$emit("pick", [
                                new Date(firstDate.setHours(0, 0, 0, 0)),
                                new Date(lastDate.setHours(23, 59, 59, 0))
                            ]);

                            // picker.$emit("pick", [firstDate, lastDate]);
                        }
                    },
                    {
                        text: "上月",
                        onClick(picker) {
                            var now = new Date();
                            var fd = new Date(now.getFullYear(), now.getMonth() - 1, 1);
                            var ed = new Date(now.getFullYear(), now.getMonth(), 0);
                            picker.$emit("pick", [fd, ed]);
                        }
                    },
                    {
                        text: "去年",
                        onClick(picker) {
                            var tYear = new Date().getFullYear() - 1;
                            var startTime = new Date(tYear, 0, 1);
                            var endTime = new Date(tYear, 11, 31); //当前年最后一天
                            picker.$emit("pick", [startTime, endTime]);
                        }
                    }
                ]
            },
            laiyuan: null,
            input: "",
            editShowInp: null,
            editName: null,
            tableData: [],
            totalRow: null,
            //排序
            order: null,
            orField: null,
            activeId: null,
            deleteVisible: false,
            data: {},
            num: null,
            count: 0,
            pagefenye: false, //点击分页 滚动条为0
            loading: false,
            isValue2Empty_box: true,
            dataLoaded: false, // 表格数据是否加载完成的状态
            c: 1,
        };
    },
    created() {
        this.loading = true;
         if (this.$store.getters.location == '') {
      this.c = 1
    }
    this.c = this.$store.getters.location;

        AdminIcoMeLabelApi({c:this.c}).then(res => {
            this.tableData = res.data.order;
            this.total = res.data.total;
            this.amount_total = res.data.amount_total;
            // this.paginationInput = res.data.limit
            this.loading = false;
        });
        //监听鼠标按下抬起事件
        window.addEventListener("keydown", this.handKeyCode, true);
        window.addEventListener("keyup", this.handKeyEvt);
    },
    beforeDestroy() {
        // 在组件生命周期结束的时候销毁
        window.removeEventListener("keydown", this.handKeyCode, false);
        window.removeEventListener("keyup", this.handKeyEvt, false);
    },
    mounted() {
        //监听页面滚动条事件
        window.addEventListener("scroll", e => this.imgScrollEvt(e), true);
    this.c = this.$store.getters.location;

    },
    methods: {
        //分页只显示前三页加总数
        showTotal(total) {
            return `共 ${total} 页`;
        },
        //按下键盘事件
        handKeyCode(e) {
            e = e || window.event;
        },

        limitEvt() {
            this.getList();
        },
        //滑动事件
        imgScrollEvt(e) {
            var e =
                document.documentElement.scrollTop ||
                window.pageYOffset ||
                e ||
                document.body.scrollTop;
            //点击分页 滚动条为0
            if (this.pagefenye == true) {
                e.scrollTop = 0;
                this.pagefenye = false;
                return;
            }
        },
        //分页
        handleCurrentChange(res) {
            this.loading = true;
            setTimeout(() => {
                this.getList();
                this.loading = false;
            }, 500);
        },
        //
        rowStyle({ row, column, rowIndex, columnIndex }) {
            if (column.label == "等级") {
                return {};
            } else if (column.label == "昵称") {
                return {};
            }
        },
        //列表排序
        sortChangeEvt(row) {
            if (row.order == "ascending") {
                this.order = "asc";
            } else if (row.order == "descending") {
                this.order = "desc";
            }
            this.orField = row.prop;
            this.getList();
        },
        //显示修改输入框
        editShowEvt(e, s) {
            this.editShowInp = e.id;
            this.editName = s;
            this.$nextTick(_ => {
                this.$refs.editInput.$refs.input.focus();
            });
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                for (let key in this.total) {
                    if (column.property == key) {
                        sums[index] = this.total[key];
                    }
                }
                if (index === 0) {
                    sums[index] = "总和";
                    return;
                } else if (index === 1) {
                    sums[index] = this.amount_total;
                    return;
                }
            });
            return sums;
        },
        //点数情况
        RechargeEvt(res) {
            switch (res) {
                case "4":
                    this.RechargeName = "会员购买";
                    break;
                case "5":
                    this.RechargeName = "购买点数";
                    break;
            }
            this.recharge = res;
            this.getList();
        },
        //按下键盘事件
        handKeyCode(e) {
            e = e || window.event;
            //Page Up 翻页
            if (e.keyCode == 34) {
                if (this.allLabel == true) {
                    return;
                }
                if (
                    this.dialogVisible == true ||
                    this.searchLabelDialog == true ||
                    this.rightLabelDialog == true ||
                    this.deleteVisible == true ||
                    this.uploadVisible == true
                ) {
                    e.preventDefault();
                    this.arrowRightEvt()
                    this.inputValue_box = ''
                    return;
                }
                this.loading = true
                e.preventDefault();
                delay(() => {
                    this.currentPage1++;
                    this.getList()
                }, 300);
            }
            // Page Down向后分页
            if (e.keyCode == 33) {
                this.loading = true
                delay(() => {
                    if (this.currentPage1 <= 1) {
                        this.currentPage1 = 1;
                    } else {
                        this.currentPage1--;
                    }
                    this.getList()
                }, 300);
            }
        },
        //获取页面数据
        getList() {
            let date = {
                start: this.value2[0],
                end: this.value2[1]
            };
            var start = Math.floor(date.start / 1000);
            var end = Math.floor(date.end / 1000);
            // 将选定的日期转换为当天的最后一秒
            var lastVaccineDate = new Date(end * 1000);
            lastVaccineDate.setHours(23, 59, 59);
            var endTimestamp = Math.floor(lastVaccineDate.getTime() / 1000);
            AdminIcoMeLabelApi({
                start: start,
                end: endTimestamp,
                type: this.recharge,
                page: this.currentPage1,
                orField: this.orField,
                orWhere: this.order,
                limit: this.paginationInput,
                c:this.c
            }).then(res => {
                this.tableData = res.data.order;
                this.total = res.data.total;
                this.amount_total = res.data.amount_total;
                this.pagefenye = true;  //点击分页 滚动条为0
                let as = document.querySelector('.el-table__body-wrapper')
                as.scrollTop = 0
                this.imgScrollEvt(as)
                this.loading = false;
                this.dataLoaded = true; // 数据加载完成，修改dataLoaded的状态
            });
        },
        //清除搜索条件
        cleanUpEvt() {
            this.authorIdInput = "";
            this.remtInput = "";
            this.value2 = "";
            this.RechargeName = "请选择";
            this.currentPage1 = 1;
            this.$refs.sortTable.clearSort();
            AdminIcoMeLabelApi({c:this.c}).then(res => {
                this.tableData = res.data.order;
                this.paginationInput = 96;
                this.amount_total = res.data.amount_total;
                this.pagefenye = true;  //点击分页 滚动条为0
                let as = document.querySelector('el-table__body-wrapper is-scrolling-none')
                this.imgScrollEvt(as);
            });
        },
        clearEvt1() {
            this.RechargeName = "请选择";
            AdminIcoMeLabelApi({c:this.c}).then(res => {
                this.tableData = res.data.order;
                this.paginationInput = res.data.limit;
                this.currentPage1 = res.page;
                this.total = res.data.total;
                this.totalRow = res.totalRow;
                this.amount_total = res.data.amount_total;
            });
        }
    },
    //点击X后清理数据后并更改值
    computed: {},
    watch: {
      '$store.getters.location': function (newLocation, oldLocation) {
          this.c = newLocation
        },
        value2: function (newVal, oldVal) {
            this.isValue2Empty_box = !newVal;
        }
    }
};
</script>

<style lang="less"  scoped>
@import url("../../../style/space.less");
@import url("../../../style/income.less");
/deep/.el-table th.el-table__cell{
    background: #F5F7FA !important;
    padding: 0 !important;
  }
.item {
    margin-top: 10px;
}

/deep/.el-input__suffix {
    color: #409eff;
}

/deep/.el-main {
    overflow: unset !important;
}

.search_box {
    position: absolute;
    top: 20px;
    left: 50px;
    width: 320px;
    height: 470px;
    border-radius: 10px;
    background-color: #fff;
    display: flex;
    justify-content: space-evenly;
    z-index: 999;
    flex-direction: column;
    justify-content: space-evenly;
    padding: 20px 10px;
    box-shadow: 0 0 10px 1px #e5e5e5;

    /*visibility: hidden;*/
    .num_box {
        width: 127px;
        border: 1px solid #e4e3e3;
        border-radius: 3px;
        margin-top: 5px;
    }
}

.all_text {
    background-color: #409eff;
    font-size: 13px;
    color: #fff;
    cursor: pointer;
    height: 26px;
    border-radius: 3px;
    width: 50px;
    text-align: center;
    line-height: 26px;
}

.caoz {
    margin-top: 8px;
    display: flex;
}

/* .block {
      position: absolute;
      margin-top: 9px;
      top: 0;
      right: 1%;
      transition: all 0.2s ease 0.5s;
    } */


.block1 {
    visibility: hidden;
}

.block1>div {
    display: none;
}

.clear {
    position: relative;
    height: 50px;

    span:nth-last-child(1) {
        background-color: #fff;
        border: 1px solid #e5e5e5;
        font-size: 13px;
        color: #c4c3c3;
        border-radius: 3px;
        position: absolute;
        right: 5px;
        bottom: -6px;
        padding: 0 10px;
        cursor: pointer;
    }
}

.demo-table-expand {
    background-color: #f2f2f2;
    font-size: 0;
}

.demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}

.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    padding: 0 20px;
    width: 30%;
}

.name_box {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;

    i {
        cursor: pointer;
        display: none;
    }
}

.name_box:hover>i {
    display: block;
}

.pagination_box {
    min-width: 500px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.num_box button {
    width: 125px;
    border: 1px solid #858585;
    background-color: #fff;
    color: #c4c3c3;
}

.rowClassOne {
    background-color: #e7ecff;
}

.rowClassTwo {
    color: #222222;
    background-color: #1c43ce;
}

.rowClassThree {
    background-color: #6a88f1;
}

.el-dropdown-link {
    cursor: pointer;
}

.notes_box {
    height: 72px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.my-icon {
    cursor: pointer;
    width: 25px;
}

/deep/.el-table thead {
    font-size: 12px;
}

/* /deep/.el-table__header-wrapper {
      background-color: #F00 !important;
      overflow-y: scroll !important;
    }
    /deep/.el-table th.el-table__cell:nth-of-type(1){
      color: #f00;
      position: fixed;
    }
    /deep/.el-table th.el-table__cell:nth-of-type(2){
      color: #f00;
    }
    /deep/.el-table th.el-table__cell:nth-of-type(3){
      color: #f00;
    }
    /deep/.el-table__fixed, .el-table__fixed-right{
      overflow-y: scroll;
    } */
/deep/.el-table__footer-wrapper {
    position: fixed;
    top: 135px;
    z-index: 111;
}

/deep/.el-table__fixed-footer-wrapper {
    display: none;
}

/deep/.el-badge__content.is-fixed {
    display: none;
}

/deep/.el-input__inner {
    color: #409eff;
    cursor: pointer;
}

.clear_ev {
    position: absolute;
    right: 10px;
}

.vip-button {
    color: #000 !important;
    background-color: #bcd9f8d4 !important;
}

/deep/.gutter {
    background: #F5F7FA !important;
}

/* 朝上排序样式 */
/deep/.el-table .ascending .sort-caret.ascending {
    background-color: #f00 !important;
    background: url("../../../img/12.png") no-repeat -4px -3px  !important;
    background-size: 11px 14px !important;
    width: 40px;
    height: 58px;
    z-index: 11;
}

/* 朝下排序样式 */
/deep/.el-table .descending .sort-caret.descending {
    background: url("../../../img/22.png") no-repeat -5px 2px !important;
    background-size: 11px 14px !important;
    width: 40px;
    height: 25px;
}

/deep/.el-table .descending .sort-caret.descending {
    border-top-color: #fff;
}

  /* 朝上字体样式 */
  /deep/.el-table__header .ascending  .cell{
    color: #409EFF !important;
  }
  /* 朝下字体样式 */
  /deep/.el-table__header .descending  .cell{
    color: #409EFF !important;
  }

.orange {
    /deep/.el-input__inner {
        background-color: #bcd9f8d4 !important;
        color: #222222;
    }

    /deep/.el-input__suffix {
        color: #222222;
    }
}

.your-css-class {
    background-color: #bcd9f8d4 !important;
    z-index: 9999;

    input {
        background-color: #bcd9f8d4 !important;
    }
}

.your-css-class_box {
    background-color: #bcd9f8d4 !important;

    input {
        background-color: #bcd9f8d4 !important;
    }
}

.orange {
    /deep/.el-input__inner {
        background-color: #bcd9f8d4 !important;
        color: #222222;
    }

    /deep/.el-input__suffix {
        color: #222222;
    }
}

//调整日期选择器的盒子大小进行修改
/deep/.el-range-editor--mini {
    height: 30px !important;
}
/deep/.source_ID{
    text-indent: 20px !important;
}
</style>
<style>
.your-css-class .el-range-input {
    background-color: #8fc6ff00 !important;
}

.your-css-class_box .el-range-input {
    background-color: #8fc6ff00 !important;
}

.selt {
    color: #909399 !important;
}

::placeholder {
    color: #858585 !important;
}

.border_box {
    border: 1px solid #858585 !important;
    border-radius: 5px
}
</style>



// WEBPACK FOOTER //
// src/translate/components/illustrate/index.vue